import React from 'react';
import { FaCheck } from 'react-icons/fa';

const StepProgressBar = ({ currentStep, steps }) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px', position: 'relative' }}>
            {/* Background Line */}
            <div style={{
                position: 'absolute',
                top: '50%',
                left: '0',
                right: '0',
                height: '2px',
                backgroundColor: '#e5e7eb',
                zIndex: 0,
                transform: 'translateY(-50%)' // Center vertically
            }}></div>

            {/* Progress Line (Colored) */}
            <div style={{
                position: 'absolute',
                top: '50%',
                left: '0',
                height: '2px',
                backgroundColor: '#4f46e5',
                zIndex: 0,
                transform: 'translateY(-50%)',
                width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
                transition: 'width 0.3s ease-in-out'
            }}></div>

            {steps.map((step, index) => {
                const stepNum = index + 1;
                const isActive = stepNum === currentStep;
                const isCompleted = stepNum < currentStep;

                return (
                    <div key={step.id} style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <div style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '50%',
                            backgroundColor: isActive || isCompleted ? '#4f46e5' : '#fff',
                            border: `2px solid ${isActive || isCompleted ? '#4f46e5' : '#e5e7eb'}`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: isActive || isCompleted ? '#fff' : '#6b7280',
                            fontWeight: 'bold',
                            fontSize: '14px',
                            transition: 'all 0.3s ease'
                        }}>
                            {isCompleted ? <FaCheck size={12} /> : stepNum}
                        </div>
                        <span style={{
                            marginTop: '8px',
                            fontSize: '12px',
                            fontWeight: isActive ? 600 : 400,
                            color: isActive ? '#111827' : '#6b7280',
                            position: 'absolute',
                            top: '32px',
                            whiteSpace: 'nowrap'
                        }}>
                            {step.label}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default StepProgressBar;
